import React, { useContext } from 'react';
import InfluencerPopup from './InfluencerPopup';
import { FormattedMessage } from 'react-intl';
import { BasePopupContext } from '../../hooks/usePopup';
import { POPUP_LARGE } from '../../constants';
import { useDispatch, useSelector } from 'react-redux';
import { PiUserSwitch, PiUserSwitchFill } from 'react-icons/pi';
import { set_active_profile } from '../../redux/slices/influencerProfileSlice';
import { setAgencyInfluencerProfile } from '../../utils';

const ProfileListing = () => {
    const { setPopup } = useContext(BasePopupContext);
    const {data} = useSelector(state => state.influencer_profile);
    const dispatch = useDispatch();
    const handlePopup = () => {
        setPopup({
            heading: <FormattedMessage id="switch_to_influencer" defaultMessage={"Switch To Influencer"} />,
            component: <InfluencerPopup />,
            size: POPUP_LARGE
        })
    }
    const handleChangeProfile = (item) => {
        dispatch(set_active_profile(item))
        setAgencyInfluencerProfile(item)
    }

    return (
        <div 
        onClick={handlePopup}
        className="flex items-center ">
            {data.map((item, index) => (
                index < 2 &&
                <>
                    <div
                        onClick={(e) =>  { e.stopPropagation(); handleChangeProfile(item)}}
                        key={index}
                        className={`hidden sm:flex cursor-pointer hover:translate-y-[-4px] hover:shadow-lg transition-all  items-center justify-center shadow-md border-2 border-primary relative ml-[-10px] bg-cover bg-no-repeat bg-center w-[35px] h-[35px] min-w-[35px] bg-white border-2 border-primary rounded-full`}
                        style={{
                            zIndex: index + 1,
                            backgroundImage: `url(${item.user.picture})`
                        }}
                    >
                        {
                            !item.user.picture &&
                            <p className='text-sm font-semibold text-primary uppercase'>
                            {item.user.name ? item.user.name[0] : ""}{item.user.sur_name ? item.user.sur_name[0] : ""}
                        </p>
                        }

                    </div>

                </>
            ))}
            {data.length > 2 && (
                <div
                    className={`hidden sm:flex cursor-pointer hover:translate-y-[-4px] hover:shadow-lg transition-all  items-center justify-center shadow-md border-2 border-primary relative ml-[-10px] bg-cover bg-no-repeat bg-center w-[35px] h-[35px] min-w-[35px] bg-white border-2 border-primary rounded-full`}
                    style={{
                        zIndex: data.length+1,
                    }}
                >
                    <p className='text-sm font-semibold text-primary uppercase'>
                        {data.length-2}+
                    </p>

                </div>
            )}
            <div className='hidden sm:block h-[2px] w-[35px] bg-primary'>

            </div>
                <div
                    className={`cursor-pointer hover:translate-y-[-4px] hover:shadow-lg transition-all flex items-center justify-center shadow-md border-2 border-primary relative bg-cover bg-no-repeat bg-center py-2 px-4  bg-white border-2 border-primary rounded-full`}
                    style={{
                        zIndex: data.length+1,
                    }}
                >
                    {/* <p className='text-xs font-semibold text-primary uppercase'>
                        {data.length-2}+
                    </p> */}
                    <p className='hidden sm:block text-[10px] font-semibold text-primary'>
                        <FormattedMessage id="change_to_influencer" defaultMessage={"Change to Influencer mode"} />
                    </p>
        <PiUserSwitchFill className='sm:hidden text-2xl text-primary' />


                </div>

        </div>
    );
};

export default ProfileListing;
